import BaseApiResponseModel, { RawData } from "api/model/BaseApiResponseModel";
import { AiOutlineAudit } from "react-icons/ai";
import AppConfigResponseModel, { MenuItem } from "./AppConfigResponseModel";
import {
  ADMIN_CONFIG,
  AGENCY_CONFIG,
  MER_CONFIG,
  STAFF_CONFIG,
  SALE_CONFIG,
} from "./mockConfig";

export interface IConfigRepository {
  getAppConfig(
    role: string,
  ): Promise<BaseApiResponseModel<AppConfigResponseModel>>;
}

export class MockConfigRepository implements IConfigRepository {
  async getAppConfig(
    role?: string,
  ): Promise<BaseApiResponseModel<AppConfigResponseModel>> {
    try {
      let response = {} as any;
      switch (role) {
        case "SUPER_ADMIN":
          response = ADMIN_CONFIG;
          break;
        case "MODERATOR":
          response = ADMIN_CONFIG;
          break;
        case "AGENCY_ADMIN":
          response = MER_CONFIG;
          break;
        case "AGENCY":
          response = AGENCY_CONFIG;
          break;
        case "STORE_USER":
          response = MER_CONFIG;
          break;
        case "NORMAL":
          response = MER_CONFIG;
          break;
        case "STAFF":
          response = STAFF_CONFIG;
          break;
        case "SALE":
          response = SALE_CONFIG;
          break;
        default:
          response = MER_CONFIG;
          break;
      }

      if (response?.data) {
        const menuItems: MenuItem[] = Object.values(response?.data).map(
          (item: any) => {
            let subMenuItems: MenuItem[] = [];

            if (item?.subMenu && item.subMenu.length > 0) {
              subMenuItems = item.subMenu.map((subItem: any) => {
                const nestedSubMenu: MenuItem[] = subItem?.subMenu?.length
                  ? subItem.subMenu.map((subMenu: any) => {
                      return new MenuItem(
                        subMenu.name,
                        subMenu.path,
                        subMenu.componentName,
                        subMenu.serviceCode || subMenu.supplierCode,
                        subMenu.icon || AiOutlineAudit,
                        [],
                      );
                    })
                  : [];

                return new MenuItem(
                  subItem.name,
                  subItem.path,
                  subItem.componentName,
                  subItem.serviceCode || subItem.supplierCode,
                  subItem.icon || AiOutlineAudit,
                  nestedSubMenu,
                );
              });
            }

            return new MenuItem(
              item.name,
              item.path,
              item.componentName,
              item.serviceCode || item.supplierCode,
              item.icon || AiOutlineAudit,
              subMenuItems,
            );
          },
        );

        return new BaseApiResponseModel<AppConfigResponseModel>(
          new RawData<AppConfigResponseModel>(
            new AppConfigResponseModel(menuItems),
          ),
          undefined,
          undefined,
        );
      } else {
        return new BaseApiResponseModel<AppConfigResponseModel>(
          new RawData(new AppConfigResponseModel([])),
          undefined,
          undefined,
        );
      }
    } catch (error) {
      console.log(error);
      return new BaseApiResponseModel<AppConfigResponseModel>(
        new RawData(new AppConfigResponseModel([])),
        undefined,
        undefined,
      );
    }
  }
}

export default new MockConfigRepository();
